import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/performance_goals/pages/RootPage'))

const GoalsListPage = React.lazy(() => import('modules/performance_goals/pages/GoalsListPage'))

export const performanceGoalsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.performanceGoals.path.replace(`${navigation.performanceProcess.path}/`, ''),
      element: <RootPage />,
      handle: {
        meta: () => {
          return {
            title: i18n.t('performance_goals.pages.goals_index.title'),
            illustration: 'goals',
          }
        },
      },
      children: [
        {
          index: true,
          element: <GoalsListPage />,
        },
      ],
    },
  ]
}
